import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";

import { useAuthUserId } from "../../../selectors/AuthSelectors";
import { useRestaurantId } from "../../../selectors/RestaurantSelectors";

import {
  getGuestmeOfferRequest,
  getGuestmeAcceptOfferRequest,
} from "../../../api";

export function useGuestmeOfferQueryKey(restaurantId: number) {
  return [useAuthUserId(), restaurantId, "guestme_offer"];
}

export function useGuestmeOffer(enabled: boolean) {
  const restaurantId = useRestaurantId();

  const {
    data: response,
    isLoading,
    isFetching,
    isFetched,
  } = useQuery({
    enabled: enabled && !!restaurantId,
    staleTime: 60 * 1000 * 30,
    queryKey: useGuestmeOfferQueryKey(restaurantId),
    queryFn: async () => {
      try {
        return await getGuestmeOfferRequest(restaurantId);
      } catch (error) {
        console.log(error);

        if (error.response?.status === 404) {
          // Возвращаем null или пустой объект вместо ошибки
          return { data: null };
        }

        throw error;
      }
    },
  });

  return {
    isFetched,
    isLoading: isLoading || isFetching,
    data: response?.data,
  };
}

export function useAcceptGuestmeOfferMutation(restaurantId: number) {
  const queryClient = useQueryClient();
  const queryKey = useGuestmeOfferQueryKey(restaurantId);

  return useMutation<GM.GuestmeOffer.Response.AcceptOffer, AxiosError>({
    mutationFn: () => getGuestmeAcceptOfferRequest(restaurantId),

    onSuccess: () => {
      queryClient.refetchQueries({ queryKey });
    },
  });
}
